import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { SimpleSelect } from "./common/SimpleSelect";

export const QuestionnaireStagingPage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [selectedOption, setSelectedOption] = useState({
		option: "",
		t: "",
		m: "",
		n: "",
	});
	const [defaultOption, setDefaultOption] = useState({
		option: "",
		t: "",
		m: "",
		n: "",
	});
	const [stagingDisabled, setStagingDisabled] = useState(true);

	const convertToOptions = (def) => {
		const ret = [];
		for (const d of def) {
			ret.push({ value: d, label: d });
		}

		return ret;
	};

	const tOptions = convertToOptions([
		"TX",
		"T0",
		"T1",
		"T1a",
		"T1b",
		"T1c",
		"T2a",
		"T2b",
		"T3",
		"T4",
		"Unknown",
	]);
	const mOptions = convertToOptions(["M0", "M1a", "M1b", "M1c", "Unknown"]);
	const nOptions = convertToOptions(["NX", "N0", "N1", "N2", "N3", "Unknown"]);

	const changeTMN = (value, type) => {
		const _selectedOption = { ...selectedOption };
		_selectedOption[type] = value;
		setSelectedOption(_selectedOption);

		const response = {
			id: def.id,
			value: _selectedOption,
		};

		onRespond(response);
	};

	const onChangeT = (sel) => {
		changeTMN(sel.value, "t");
	};

	const onChangeM = (sel) => {
		changeTMN(sel.value, "m");
	};

	const onChangeN = (sel) => {
		changeTMN(sel.value, "n");
	};

	useEffect(() => {
		let opt = defaultOption;

		if (def.options) {
			for (const o of def.options) {
				if (o.default) {
					opt.option = o.value;
					break;
				}
			}
		}

		setDefaultOption(opt);

		if (!currentResponse) {
			const response = {};
			response.id = def.id;
			response.value = opt;

			onRespond(response);
		}
	}, [def]);

	useEffect(() => {
		if (currentResponse && currentResponse.value) {
			const val = currentResponse.value;
			setSelectedOption(val);

			setStagingDisabled(val.option !== "Will specify");
		} else if (def.answer) {
			setSelectedOption(def.answer);
			setStagingDisabled(def.answer.option !== "Will specify");

			const response = {
				id: def.id,
				value: def.answer,
			};
			onRespond(response);
		} else {
			setSelectedOption({ ...defaultOption });
		}
	}, [currentResponse, def, onRespond, defaultOption]);

	const onChangeOption = (e) => {
		const checked = e.target.checked;
		let value = checked ? e.target.value : defaultOption.option;

		setStagingDisabled(value !== "Will specify");

		const _selectedOption = { ...selectedOption };
		_selectedOption.option = value;

		const response = {
			id: def.id,
			value: _selectedOption,
		};

		if (value === "Will specify") {
			_selectedOption.t = tOptions[0].value;
			_selectedOption.n = nOptions[0].value;
			_selectedOption.m = mOptions[0].value;
		} else {
			_selectedOption.t = "";
			_selectedOption.n = "";
			_selectedOption.m = "";
		}

		setSelectedOption(_selectedOption);
		onRespond(response);
	};

	const renderOptions = (s) => {
		return def.options
			? def.options.map((option, i) => (
					<div key={`${i}_option`} className={option.hidden ? "hidden" : ""}>
						<label
							key={`${i}_label`}
							className={`${
								s === option.value.toString()
								? `bg-black text-white font-medium`
								: "bg-gray-100 text-black"
							} text-right text-base sm:text-lg leading-5 sm:leading-6 font-normal rounded-full mx-3 option pr-2 pl-7 py-2.5 cursor-pointer flex items-center justify-end my-3 lg:my-4`}
						>
							{option.label}
							<span className={`flex flex-0-0-auto justify-center items-center w-4 h-4 text-white border border-gray-400 rounded mx-2.5`}>
								{s === option.value.toString() && <FaCheck size={8} />}
							</span>
							<input
								key={`${i}_input`}
								name={def.title}
								value={option.value.toString()}
								className={"hidden "}
								type="checkbox"
								checked={s === option.value.toString()}
								onChange={onChangeOption}
							/>
						</label>
					</div>
			  ))
			: null;
	};

	return (
		<>
			<div key="staging-holder" className={"w-full pb-3 xs:pb-6 px-6 text-black text-center"}>
				{def.preamble ? <p className={"text-sm mb-1"}>{def.preamble}</p> : null}
				{def.title ? (
					<h2 className={"text-xl-eq font-bold"}>{def.title.toUpperCase()}</h2>
				) : null}
				{def.question ? <p className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>{def.question}</p> : null}
				{def.description ? (
					<p className={"text-sm"}>{def.description}</p>
				) : null}
			</div>

			<div className="radioSelect black-white">
				{renderOptions(selectedOption.option)}
			</div>

			<div className="grid grid-cols-3 gap-2 px-6 mt-4">
				<div className="text-center">T</div>
				<div className="text-center">N</div>
				<div className="text-center">M</div>
				<div className="">
					<SimpleSelect
						name="t"
						id="t"
						key="t"
						options={tOptions}
						value={{ value: selectedOption.t, label: selectedOption.t }}
						onChange={onChangeT}
						classes="w-full"
						disabled={stagingDisabled}
						isSearchable={false}
					/>
				</div>
				<div className="">
					<SimpleSelect
						name="n"
						id="n"
						key="n"
						options={nOptions}
						value={{ value: selectedOption.n, label: selectedOption.n }}
						onChange={onChangeN}
						classes="w-full"
						disabled={stagingDisabled}
						isSearchable={false}
					/>
				</div>
				<div className="">
					<SimpleSelect
						name="m"
						id="m"
						key="m"
						options={mOptions}
						value={{ value: selectedOption.m, label: selectedOption.m }}
						onChange={onChangeM}
						classes="w-full"
						disabled={stagingDisabled}
						isSearchable={false}
					/>
				</div>
			</div>
		</>
	);
};
